import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { ComPhoto, BookMarkStore, BuyerPopup, Alert, GoodsPhoto,  GoodsCategory, GoodsFilter } from '../../../js/ComponentManager'
import before from '../../../img/before.svg';
import search from '../../../img/search.svg';
import cart from '../../../img/cart.svg';
import deal_icon from '../../../img/deal_icon.svg';
import wait from '../../../img/wait.svg';
import { WhNoticeList } from './WhNoticeList';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { DataContext } from '../../Layout';

/* 개발담당:양유빈
 * 화면기능:매장상세
 * 세부설명:
*/

export class StoreDtl extends Component {
    static displayName = StoreDtl.name;
    static contextType = DataContext;

    constructor(props) {
        super(props);
        this.state = {
            HideName: "First2",
            Bookmark_Store_Yn: "N",
            BasketCount: 0,
            ApprStatus: "",
            Title: "",
            GoodsBest:[],
            Notice:[],
            WholeInfo: [],
            GoodsList: [],
            GoodListPush: []
        };
        this.CsName = Big3Common.ContentState;
        this.ref_BuyerPopup = React.createRef();
        this.GoodsCategoryRef = React.createRef();
        this.GoodsFilterRef = React.createRef();
        

        this.Uid = "";
        if (this.props.ContentState !== undefined) {
            this.Uid = this.props.ContentState[this.CsName.Uid] !== undefined ? this.props.ContentState[this.CsName.Uid] : "";
        }

        this.CategoryCallback = this.CategoryCallback.bind(this);
        this.handelFilterInit = this.handelFilterInit.bind(this);
        this.FilterCallback = this.FilterCallback.bind(this);

        this.handle_onScroll = this.handle_onScroll.bind(this);
        this.handleBuyer_Click = this.handleBuyer_Click.bind(this);
        this.handleConnet_Click = this.handleConnet_Click.bind(this);
        this.handleGoodsLink_Click = this.handleGoodsLink_Click.bind(this);
        
    }
   
    //초기화
    async componentDidMount() {

        //Authentication 설정하지 않거나, 처리하지 않는다고 명시 할때만
        await Big3Common.Authentication(this);
        window.addEventListener('scroll', this.handle_onScroll);
        await this.CallWholeDefaultInfo();
        await this.CallAllGoodsList();
       
    }
    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handle_onScroll);
        
    }
    handle_onScroll(event) {
        if (event.srcElement.scrollingElement.scrollTop >= 350 && this.state.HideName === "First2") {
            this.setState({ HideName: "First1" });
        }
        else if (event.srcElement.scrollingElement.scrollTop < 350 && this.state.HideName === "First1") {
            this.setState({ HideName: "First2" });
        }
    }
    async CallWholeDefaultInfo() {
        try {
           
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get(`api/Search/Store/GetWholeDefaultInfo/${this.Uid}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                               
                const DataList = JSON.parse(Data.multiDataTable);
                const WholeInfo = DataList.WholeInfo;
                const BookmarkYn = DataList.BookmarkYn;
                const BasketCount = DataList.BasketCount;
                const ApprStatus = DataList.ApprStatus;
                const Notice = DataList.Notice;
                const GoodsBest = DataList.GoodsBest;
                this.setState({
                    WholeInfo: WholeInfo, 
                    Bookmark_Store_Yn: BookmarkYn,
                    BasketCount: BasketCount,
                    ApprStatus: ApprStatus,
                    Notice: Notice,
                    GoodsBest: GoodsBest
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallWholeDefaultInfo", e);
        }
        return false;
    }
    SearchModel = {
        Uid:"",
        Man_Cd: "",
        Mid_Cd: "",
        Sub_Cd: "",
        Display: "all",
        Order_By: "reg_dt",
        Start_Price: 0,
        End_Price: 1000000,
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size 
    }
    //전체상품
    async CallAllGoodsList() {
        try {

            this.SearchModel.Uid = this.Uid;
            let Data = await Big3Common.Post(`api/Search/Store/GetUidGoodsList`, this.SearchModel,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
               
                let GoodsList = JSON.parse(Data.dataTable);
                let GoodListPush = this.state.GoodListPush;
                GoodsList.map(list => GoodListPush.push(list));
                this.setState({ GoodsList: GoodsList, GoodListPush: GoodListPush });                
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallAllGoodsList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        
        return false;
    }
    //카테고리 필터조건 Callback 함수
    CategoryCallback(CategoryCd) {

        this.SearchModel.Man_Cd = CategoryCd.Man_Cd;
        this.SearchModel.Mid_Cd = CategoryCd.Mid_Cd;
        this.SearchModel.Sub_Cd = CategoryCd.Sub_Cd;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.setState({ GoodsList: [], GoodListPush: [] });

        this.CallAllGoodsList();
    }
    //필터조건 검색 Callback 함수
    FilterCallback(Filter) {

        this.SearchModel.Display = Filter.Display;
        this.SearchModel.Order_By = Filter.Order_By;
        this.SearchModel.Start_Price = Filter.Start_Price;
        this.SearchModel.End_Price = Filter.End_Price;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.setState({ GoodsList: [], GoodListPush: [] });
        this.CallAllGoodsList();
    }
    //필터 초기화
    handelFilterInit() {

        this.GoodsCategoryRef.current.CategoryDataCall();
        this.GoodsFilterRef.current.handleClear_Click();

        this.SearchModel.Man_Cd = "";
        this.SearchModel.Mid_Cd = "";
        this.SearchModel.Sub_Cd = "";
        this.SearchModel.Display = "all";
        this.SearchModel.Order_By = "reg_dt";
        this.SearchModel.Start_Price = 0;
        this.SearchModel.End_Price = 1000000;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.setState({ GoodsList: [], GoodListPush: [] });

        this.CallAllGoodsList();
    }
    //사입요청
    handleBuyer_Click(event, whole_code) {
        this.ref_BuyerPopup.current.initWholeCode(whole_code)
        Big3Common.ModalAlert(bootstrap, 'BuyerPopup');
        event.preventDefault();
    }
    //거래신청
    async handleConnet_Click(event) {
        let Data = await Big3Common.Get(`api/Search/Store/RegisterRetailGrupApprStatus/${this.Uid}`);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            this.setState({ Title: Data.message, ApprStatus:"WA" });
        }
        else {
            this.setState({ Title: Data.message });
        }
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        event.preventDefault();
    }
    //상세이동
    handleGoodsLink_Click(event, list) {
        this.props.RenderComponent("GoodsDtl", {
            [this.CsName.Uid]: list.uid,
            [this.CsName.Goods_No]: list.goods_no,
            [this.CsName.BackUrl]:"StoreDtl"
        });
        event.preventDefault();
    }
    async handleGoodsDtl_Click(e, list) {
        this.context.Layout_GoodsDtl(
        {
            goods_no: list.goods_no,
            uid: list.uid,
            isshow: true,
            headhide: true,
            scrollevent: false
        });
    }
    RenderCount = 0;
    MainGoodsrender() {
        this.RenderCount++;
        let RetailConnetrender = this.RetailConnetrender();
        if (this.state.GoodsBest.length > 0) {
            const Goods = this.state.GoodsBest[0];
            const ImageSrc = Goods.img_1000;
            const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
            return (
                <div className="product_dtl_img_box"
                    style={{ backgroundImage: `url(${VirtualRoot}${ImageSrc})` }}
                >
                    <div className="product_title">
                        {Goods.dtl_content.toString().replaceAll("\n", "")}
                    </div>
                    <div className="detail_view" onClick={(e) => this.handleGoodsDtl_Click(e, Goods)}>
                        자세히보기
                    </div>
                    {RetailConnetrender}
                </div>
            )
        }
        else if (this.RenderCount > 1) {
            return (
                <div className="product_dtl_img_box">
                    {RetailConnetrender}
                </div>
            )
        }
        else {
            return (
                ""
            )
        }
    }
    //도매 기본정보
    Memberrender() {

        if (this.state.WholeInfo.length === 0) return false;
        const Member = this.state.WholeInfo[0];
        return (
            <div className="gdl_shop_info_box">                
                <ComPhoto
                    className="shop_img"
                    Photo={Member.photo}
                />
                <div className="shop_info">
                    <div className="shop_name">
                        <div className="name">{Member.whole_name}</div>
                        <div className="shop_icon_box">
                            <div className="call" onClick={() => { window.location.href = `tel:${Member.user_phone}` }} ></div>
                            <BookMarkStore
                                Whole_Code={Member.whole_code}
                                HeartOn={this.state.Bookmark_Store_Yn === "Y" ? true : false}
                            />
                        </div>
                    </div>
                    <div className="shop_name">
                        <div className="add">{`${Member.bld_name} ${Member.flr_name}층 ${Member.whole_no_name}호`}</div>
                        <div className="shop_icon_box">
                            <Link to={`/Chat/LiveChat/Index?uid=${this.Uid}`} >
                                <button>채팅하기</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    //거래요청버튼
    RetailConnetrender() {
        //CA: 거절,거래중지
        //WA: 거래요청, 거래대기
        //AP: 승인
        const ApprStatus = this.state.ApprStatus;
        if (ApprStatus === undefined || ApprStatus === null || ApprStatus === "" || ApprStatus === "CA") {
            return (
                <div className="deal" onClick={this.handleConnet_Click }>
                    <div><img src={deal_icon} alt="거래신청" /></div>
                    거래신청
                </div>
            )
        }
        else if (ApprStatus === "WA") {
            return (
                <>
                    <div className="deal wait">
                        <div><img src={wait} alt="거래대기" /></div>
                        거래대기
                    </div>
                </>
            )
        }
        else {
            return ("");
        }
    }
    //도매 공지사항
    Noticerender() {
        
        if (this.state.Notice.length === 0) {
            return ("");
        }
        else {
            const Notice = this.state.Notice[0];
            return (
                <div className="gdl_shop_notice_box">
                    <div className="noctice_title">{Notice.noti_title }</div>
                    <div className="noctice_date">{Notice.reg_dt}</div>
                    <div className="noctice_cont">{Notice.noti_contt}</div>
                    <div className="list_view" onClick={(e) => { Big3Common.ModalAlert(bootstrap, 'WhNoticeList');e.preventDefault(); } }>이전목록보기</div>
                </div>
            )
        }
    }
    //베스트 10
    GoodsBestrender() {
        const DataList = this.state.GoodsBest;
        const slidersCount = 3;
        return (
           
             <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="recent_poroducts row row-cols-3 no_line">
                        <div>
                            {
                                DataList.map((list, idx) =>
                                    <SwiperSlide className="product" key={idx} onClick={(e) => { this.handleGoodsDtl_Click(e, list) }}> 
                                        <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                            Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                            CallBack={this.CallBoorkMarkGoodsData}
                                            SoldoutYn={list.soldout_yn}
                                            SimilarityYn="Y"
                                        />
                                        <div className="shop_name">{list.org_nm}</div>
                                        <div className="product_name">{list.goods_nm}</div>
                                        <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                        {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                                    </SwiperSlide>
                                     
                                )}
                        </div>
                        <SwiperSlide className="word_box3">
                            {/* 공백*/}
                        </SwiperSlide>
                    </Swiper>
        )
    }
    GoodsListAllrender() {
        let GoodListPush = this.state.GoodListPush;
        return (
            <div className="recent_poroducts recent_poroducts_v2 row row-cols-2 ">
                {
                    GoodListPush.map(list =>
                        <div className="product" key={list.file_no} onClick={(e) => { this.handleGoodsDtl_Click(e, list); }}>
                            <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                SoldoutYn={list.soldout_yn}
                                SimilarityYn="Y"
                            />
                            <div className="shop_name">{list.org_nm}</div>
                            <div className="product_name">{list.goods_nm}</div>
                            <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                            {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                        </div>
                    )
                }
                {
                    GoodListPush.length > 0 ? "" : 
                        <div className="result_no_box">
                            <div className="no_result">
                                <div className="icon"></div>
                                <div className="text">검색결과가 없습니다.</div>
                            </div>
                        </div>
                }
            </div>
        )
    }
    render() {
        let Memberrender = this.Memberrender();
        let MainGoodsrender = this.MainGoodsrender();
        let Noticerender = this.Noticerender();
        let GoodsBestrender = this.GoodsBestrender();
        let GoodsListAllrender = this.GoodsListAllrender();
        return (
            <>
                <div id="parent_goods_list">
                    <header style={this.state.HideName === "First2" ? { backgroundColor: "transparent" } : { backgroundColor: "#ffff" }}>
                        <div className={this.state.HideName === "First1" ? "item_hide" : "nav nav_2"}>
                            <div className="before">
                                <img src={before} alt="이전화면" className="white" onClick={() => { Big3Common.Util.HistoryBack(this); }} />
                            </div>
                            <div className="header_icon_box2">
                                <div className="main_alarm">
                                    {
                                        window.location.pathname === '/Search/Goods/Index' ?
                                            <img src={search} alt="검색아이콘" className="white" onClick={() => { this.props.RenderComponent("SearchHome") }} />
                                            :
                                            <Link to={"/Search/Goods/Index"}>
                                                <img src={search} alt="검색아이콘" className="white" />
                                            </Link>
                                    }
                                </div>
                                <div className="main_alarm">
                                    <Link to="/MyPage/Basket/Index">
                                        <img src={cart} alt="카트아이콘" className="white" />
                                        <span><b>{this.state.BasketCount}</b></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.HideName === "First2" ? "item_hide" : "nav"} >
                            <div className="before">
                                <img src={before} alt="이전화면" onClick={() => { Big3Common.Util.HistoryBack(this); }} />
                            </div>

                            <div className="header_icon_box2">
                                <div className="main_alarm">
                                    {
                                        window.location.pathname === '/Search/Goods/Index' ?
                                            <img src={search} alt="검색아이콘" onClick={() => { this.props.RenderComponent("SearchHome") }} />
                                            :
                                            <Link to={"/Search/Goods/Index"}>
                                                <img src={search} alt="검색아이콘" />
                                            </Link>
                                    }
                                </div>
                                <div className="main_alarm">
                                    <Link to="/MyPage/Basket/Index">
                                        <img src={cart} alt="카트아이콘" />
                                        <span><b>{this.state.BasketCount}</b></span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                    </header>
                    <div className="good_dtl_box">
                        {MainGoodsrender}
                        {Memberrender}
                        {Noticerender}
                        <div className="line_v2"></div>
                        <div className="recent_product u_padding">
                            <div className="title_box">
                                <div className="title">베스트 10</div>
                            </div>
                            {GoodsBestrender}
                        </div>
                        <div className="recent_product u_padding">
                            <div className="title_box title_box_v2">
                                <div className="title">전체상품</div>
                            </div>
                            <div className="select_box">
                                <div className="category_box" onClick={(event) => {
                                    Big3Common.ModalAlert(bootstrap, 'GoodsCategory');
                                    event.preventDefault();
                                }}>
                                    <div className="category">카테고리</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box filter"
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsFilter');
                                        event.preventDefault();
                                    }}>
                                    <div className="category filter">필터</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box reset" onClick={this.handelFilterInit}>
                                    <div className="category">초기화</div>
                                    <div className="reset_btn"></div>
                                </div>
                            </div>
                            {GoodsListAllrender}
                            {this.SearchModel.Page_Size === this.state.GoodsList.length ? <div className="more_btn_box mbtn_v2"><button className="more_btn" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
                        </div>

                    </div>
                    <BuyerPopup
                        id="BuyerPopup"
                        ref={this.ref_BuyerPopup}
                    />
                    <Alert
                        id="MessageAlert"
                        title={this.state.Title}
                    />

                    <GoodsCategory
                        id="GoodsCategory"
                        CallBack={this.CategoryCallback}
                        ref={this.GoodsCategoryRef}
                    />
                    <GoodsFilter
                        id="GoodsFilter"
                        CallBack={this.FilterCallback}
                        ref={this.GoodsFilterRef}
                    />
                    <WhNoticeList
                        id="WhNoticeList"
                        Wuid={this.Uid}
                    />
                </div>
            </>
        );
    }
}
